<template>
  <section
    class="max-w-4xl px-6 py-12 mx-auto text-neutral-800 dark:text-neutral-100"
  >
    <h1 class="mb-6 text-3xl font-bold">
      {{ $t("termsOfUse.title") }}
    </h1>

    <article class="space-y-10">
      <section>
        <h2 class="mb-2 text-xl font-semibold">
          {{ $t("termsOfUse.introTitle") }}
        </h2>
        <p>{{ $t("termsOfUse.introText") }}</p>
      </section>

      <section>
        <h2 class="mb-2 text-xl font-semibold">
          {{ $t("termsOfUse.siteUsage.title") }}
        </h2>
        <p>{{ $t("termsOfUse.siteUsage.text") }}</p>
      </section>

      <section>
        <h2 class="mb-2 text-xl font-semibold">
          {{ $t("termsOfUse.services.title") }}
        </h2>
        <ul class="ml-6 space-y-2 list-disc">
          <li>{{ $t("termsOfUse.services.item1") }}</li>
          <li>{{ $t("termsOfUse.services.item2") }}</li>
        </ul>
      </section>

      <section>
        <h2 class="mb-2 text-xl font-semibold">
          {{ $t("termsOfUse.intellectualProperty.title") }}
        </h2>
        <p>{{ $t("termsOfUse.intellectualProperty.text") }}</p>
      </section>

      <section>
        <h2 class="mb-2 text-xl font-semibold">
          {{ $t("termsOfUse.disclaimer.title") }}
        </h2>
        <p>{{ $t("termsOfUse.disclaimer.text") }}</p>
      </section>

      <section>
        <h2 class="mb-2 text-xl font-semibold">
          {{ $t("termsOfUse.privacy.title") }}
        </h2>
        <p>{{ $t("termsOfUse.privacy.text") }}</p>
      </section>

      <section>
        <h2 class="mb-2 text-xl font-semibold">
          {{ $t("termsOfUse.changes.title") }}
        </h2>
        <p>{{ $t("termsOfUse.changes.text") }}</p>
      </section>

      <section>
        <h2 class="mb-2 text-xl font-semibold">
          {{ $t("termsOfUse.law.title") }}
        </h2>
        <p>{{ $t("termsOfUse.law.text") }}</p>
      </section>
    </article>
  </section>
</template>
<script setup lang="ts">
const i18n = useI18n();
useSeoMeta({
  title: i18n.t("legalKeys.termsOfUse"),
});
</script>
